import React from 'react';
import { Container as StyledContainer } from './Container.styled';

const Container = ({ children }: { children: JSX.Element | JSX.Element[] }): JSX.Element => (
  <StyledContainer>{children}</StyledContainer>
);

export default Container;
